<template>
  <div v-if="data?.message" class="confirm-modal__message">
    <div v-if="data?.isHtml" v-html="data.message" />
    <div v-else>{{ data.message }}</div>
  </div>
  <div
    v-if="data?.extraBtnText && data?.onExtra"
    class="confirm-modal__extra"
  >
    <CustomButton
      outline
      color="primary"
      no-caps
      :loading="extraLoading"
      :disable="loading"
      @click="onExtraClick"
    >
      {{ data.extraBtnText }}
    </CustomButton>
  </div>
  <CustomModalFooter
    :btn-loading="this.loading"
    :submit-btn-text="this.data?.btnText || 'Подтвердить'"
    :on-submit="this.onSubmit"
    :onCancel="this.closePopup"
    :cancelBtnText="this.data?.cancelBtnText || 'Отмена'"
  />
</template>

<script>
import CustomButton from "@/components/common/CustomButton.vue";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { useAppStore } from "@/services/store/app";

export default {
  name: 'ConfirmModal',
  props: ['data'],
  data() {
    return {
      loading: false,
      extraLoading: false,
    }
  },
  components: { CustomButton, CustomModalFooter },
  methods: {
    async onExtraClick() {
      if (!this.data?.onExtra) return
      this.extraLoading = true
      try {
        await this.data.onExtra()
      } finally {
        this.extraLoading = false
      }
    },
    async closePopup() {
      if(this.data.onReject) {
        await this.data.onReject()
        return
      }
      this.closeModal()
    },
    async onSubmit() {
      this.loading = true
      this.data?.onSubmit && await this.data.onSubmit()
      this.loading = false
    }
  },
  setup() {
    const {closeModal} = useAppStore()
    return {closeModal}
  }
};
</script>

<style scoped lang="scss">
.title {
  margin-bottom: 15px;
  text-align: center;
}

.confirm-modal__message {
  padding: 8px 0 16px;
  color: #374151;
  line-height: 1.6;
}

.confirm-modal__extra {
  padding: 0 0 12px;
}
</style>
